import {
    ROUTES_PUBLIC_LIVE,
    ROUTES_PUBLIC_LIVE_STATISTIC,
    ROUTES_PUBLIC_LIVE_STATISTIC_CREW,
    ROUTES_PUBLIC_LIVE_STATISTIC_CREW_STROKE_RATE,
    ROUTES_PUBLIC_LIVE_STATISTIC_CREW_DISTANCE,
    ROUTES_PUBLIC_LIVE_STATISTIC_CREW_PACE,
    ROUTES_PUBLIC_LIVE_STATISTIC_CREWS,
    ROUTES_PUBLIC_LIVE_STATISTIC_TIME,
    ROUTES_PUBLIC_LIVE_STATISTIC_CREWS_RATE_PACE,
    ROUTES_PUBLIC_LIVE_STATISTIC_CREWS_REVERSE_RATE_PACE
} from '@/constants/routes';
import { LUDUM_ERROR_CODES } from '@/constants';
const { OK } = LUDUM_ERROR_CODES;
import store from '@/store';
import { i18n } from '@/lang';
import Echo from 'laravel-echo';

export default {
    path: '/public',
    name: 'public',
    component: () => import(/* webpackChunkName: 'public-live' */ '@/views/public/Live'),
    children: [
        {
            path: '/public/live/:uuid',
            name: ROUTES_PUBLIC_LIVE,
            beforeEnter: beforeEnterLive,
            component: () => import(/* webpackChunkName: 'public-live' */ '@/components/public/live/Live')
        },
        {
            path: '/public/statistic/:uuid',
            name: ROUTES_PUBLIC_LIVE_STATISTIC,
            beforeEnter: beforeEnterLive,
            component: () => import(/*webpackChunkName: 'public-live'*/ '@/components/public/live/widget-statistic/LiveStatistic')
        },
        {
            path: '/public/statistic-crew/:uuid/:id',
            name: ROUTES_PUBLIC_LIVE_STATISTIC_CREW,
            beforeEnter: beforeEnterLive,
            component: () => import(/*webpackChunkName: 'public-live'*/ '@/components/public/live/widget-statistic/LiveNewStatisticCrew')
        },
        {
            path: '/public/statistic-crew/:uuid/:id/stroke-rate',
            name: ROUTES_PUBLIC_LIVE_STATISTIC_CREW_STROKE_RATE,
            beforeEnter: beforeEnterLive,
            component: () => import(/*webpackChunkName: 'public-live'*/ '@/components/public/live/widget-statistic/LiveNewStatisticCrewSingle')
        },
        {
            path: '/public/statistic-crew/:uuid/:id/distance',
            name: ROUTES_PUBLIC_LIVE_STATISTIC_CREW_DISTANCE,
            beforeEnter: beforeEnterLive,
            component: () => import(/*webpackChunkName: 'public-live'*/ '@/components/public/live/widget-statistic/LiveNewStatisticCrewSingle')
        },
        {
            path: '/public/statistic-crew/:uuid/:id/pace',
            name: ROUTES_PUBLIC_LIVE_STATISTIC_CREW_PACE,
            beforeEnter: beforeEnterLive,
            component: () => import(/*webpackChunkName: 'public-live'*/ '@/components/public/live/widget-statistic/LiveNewStatisticCrewSingle')
        },
        {
            path: '/public/statistic-crews/:uuid',
            name: ROUTES_PUBLIC_LIVE_STATISTIC_CREWS,
            beforeEnter: beforeEnterLive,
            component: () => import(/*webpackChunkName: 'public-live'*/ '@/components/public/live/widget-statistic/LiveNewStatisticCrews')
        },
        {
            path: '/public/statistic/:uuid/time',
            name: ROUTES_PUBLIC_LIVE_STATISTIC_TIME,
            beforeEnter: beforeEnterLive,
            component: () => import(/*webpackChunkName: 'public-live'*/ '@/components/public/live/widget-statistic/LiveStatisticTime')
        },
        {
            path: '/public/statistic/:uuid/crews-rate-pace',
            name: ROUTES_PUBLIC_LIVE_STATISTIC_CREWS_RATE_PACE,
            beforeEnter: beforeEnterLive,
            component: () => import(/*webpackChunkName: 'public-live'*/ '@/components/public/live/widget-statistic/statistic-crews-rate-pace/StatisticCrewsRatePace')
        },
        {
            path: '/public/statistic/:uuid/crews-reverse-rate-pace',
            name: ROUTES_PUBLIC_LIVE_STATISTIC_CREWS_REVERSE_RATE_PACE,
            beforeEnter: beforeEnterLive,
            component: () => import(/*webpackChunkName: 'public-live'*/ '@/components/public/live/widget-statistic/statistic-crews-rate-pace/StatisticCrewsRatePaceReverse')
        }
    ]
};

async function beforeEnterLive(to, from, next) {
    const { status_code } = await store.dispatch('sessionResultsLive/getSession', to.params.uuid);
    if (status_code !== OK) {
        next({ path: '404' })
    } else {
        const { status_code } = await store.dispatch('sessionResultsLive/fetchLastLiveResults', to.params.uuid);
        if (status_code !== OK) {
            next({ path: '404' })
        } else {
            to.name === ROUTES_PUBLIC_LIVE  && loadGoogleMaps();
            initSocketIo();
            next();
        }
    }
}

export function initSocketIo() {
    window.io = require('socket.io-client');
    window.Echo = new Echo({
        broadcaster: 'socket.io',
        host: process.env.VUE_APP_SOCKET_URL,
        transports: ['websocket', 'polling', 'flashsocket'],
        enabledTransports: ['ws', 'wss'],
        encrypted: true
    });
}

export function loadGoogleMaps() {
    store.commit('clubHelper/updateGoogleMaps', false);
    return Vue.loadScript(
        `https://maps.googleapis.com/maps/api/js?v=3.47.6&key=${process.env.VUE_APP_GOOGLE_API_KEY}&libraries=places&language=${i18n.locale}`
    )
        .then(() => {
            store.commit('clubHelper/updateGoogleMaps', true);
        })
        .catch(error => {
            // Failed to fetch script
            console.info('Failed to load Google Maps', error);
            store.commit('clubHelper/updateGoogleMaps', false);
        });
}
